import React, { useEffect, useState } from "react";
import DotGrid from "./DotGrid";

export default function DotGridBackground() {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const updateTheme = () => {
      setIsDark(document.documentElement.classList.contains("dark"));
    };

    updateTheme();

    const observer = new MutationObserver(updateTheme);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="fixed inset-0 z-0 pointer-events-none">
      <DotGrid
        dotSize={4}
        gap={18}
        baseColor={isDark ? "#ffffff30" : "#00000025"}   // more visible
        activeColor={isDark ? "#8b5cf6" : "#000000"}    // violet in dark
        proximity={180}
        shockRadius={260}
        shockStrength={6}
        resistance={700}
        returnDuration={1.5}
        className="h-full w-full"
      />
    </div>
  );
}
